// extracted by mini-css-extract-plugin
export default {"statusBadge":"statusBadge---c3DVv","statusDot":"statusDot---tpguD","active":"active---yiXgP","inactive":"inactive---YL0sc"};